import {Component, Inject} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogContent} from "@angular/material/dialog";
import {TranslatableComponent} from "src/app/core/models/TranslatableComponent";
import {Router} from "@angular/router";
import {MatIcon} from "@angular/material/icon";
import {CdkScrollable} from "@angular/cdk/scrolling";
import {MatNavList, MatListItem} from "@angular/material/list";
import {EscapeHotkeyDirective} from "../../hotkey/directives/escape-hotkey.directive";

@Component({
	selector: "app-navigate-dialog",
	templateUrl: "./navigate-dialog.component.html",
	styleUrls: ["./navigate-dialog.component.scss"],
	imports: [MatIcon, CdkScrollable, MatDialogContent, MatNavList, MatListItem, EscapeHotkeyDirective],
})
export class NavigateDialogComponent extends TranslatableComponent {
	constructor(
		public dialogRef: MatDialogRef<NavigateDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			value: string;
			viewValue: string;
		}[],
		protected translate: TranslateService,
		public router: Router,
	) {
		super(translate, "NavigateDialogComponent");
		dialogRef.addPanelClass("mep-dialog");
	}

	onCloseClick(): void {
		this.dialogRef.close();
	}
}
